export default {
    lotteryQr: ' Código de lotería Qr',
    checkResult: ' El resultado verificación debe',
    downloadApp: ' Descargar APP',
    prize: ' premio',
    introTitle: 'How to conduct a lottery and claim prizes',
    lotteryRule: ' Reglas lotería',
    checkDetailsHint: '（Haga clic para ver los detalles）',
    addCardHint1: 'Agrega tu',
    addCardHint2: 'tarjeta a Laidan',
    howGetCard: 'Cómo obtener tu tarjeta',
    getCardText: 'Puedes obtener tu tarjeta a través de la aplicación móvil gratuita Laidan',
    flowTitle1: 'Descarga Laidan',
    flowText1: 'Si no tienes Laidan, puedes usarlo para simplificar tu billetera',
    flowTitle2: 'Agrega tu tarjeta',
    flowText2: 'Una vez que hayas instalado Laidan, ¡haz clic en este botón para agregar la tarjeta a la aplicación!',
    flowTitle3: '¡Todo listo!',
    flowText3: '¡Disfruta de tu experiencia de compra móvil mejorada!',
    flowBtnText1: 'Obtener',
    flowBtnText2: 'Descargar desde',
    flowBtnText3: 'Agregar a',
    merchantOs: 'Tu propio sistema de comercio',
    howCreateOs: 'Cómo crear tu sistema',
    createOsText: 'Puedes administrar tus productos y crear un sistema de membresía con la aplicación móvil gratuita Joinku',
    kuTitle1: 'Descarga Joinku',
    kuText1: 'Si no tienes Joinku, puedes usarlo para ahorrar tiempo valioso',
    kuTitle2: 'Consulta tu sistema',
    kuText2: 'Una vez que hayas instalado Joinku, ¡haz clic en este botón para ver los miembros y los pedidos!',
    kuTitle3: '¡Todo listo!',
    kuText3: '¡Disfruta de tu experiencia de gestión de sistema mejorada!',
    taxExpert: 'Tu experto en facturación electrónica',
    howGetTax: 'Cómo obtener tu factura electrónica',
    getTaxText: 'Puedes recibir tu factura electrónica y participar en sorteos de comerciantes a través de la aplicación móvil gratuita Laidan',
    danTitle1: 'Descarga Laidan',
    danText1: 'Si no tienes Laidan, puedes usarlo para disfrutar de más ofertas',
    danTitle2: 'Explora tus ofertas',
    danText2: 'Una vez que hayas instalado Laidan, ¡haz clic en este botón para participar en tus ofertas!',
    danText3: '¡Disfruta de tu experiencia móvil de ofertas mejorada!',
    inviteCashDedu: 'Descuento en efectivo por invitación',
    inviteCode: 'Código de invitación',
    copyInviteCode: 'Haz clic para copiar el código de invitación',
    copySucceed: '¡Copiado exitosamente!',
    copyError: 'Error al copiar',
    memberSystem: 'Sistema de membresía',
    memberSystemText: 'Por cada nuevo usuario que invites a registrarse en Joinku utilizando tu código de invitación, recibirás un descuento de 100€ en la tarifa anual',
    inviteTitle2: 'Configurar el código de invitación',
    inviteText2: 'Una vez que hayas instalado Joinku, primero copia el código de invitación y luego haz clic en este botón para ir a Joinku',
    inviteText3: '¡Obtén un descuento en efectivo en la tarifa anual!',
    flowBtnText4: 'Explorar',
    phoneLabel: 'Teléfono:',
    addressLabel: 'DIRECCIÓN:',
    readAndAccept: 'leer y aceptar',
    privacyPolicy: 'política de privacidad',
    startLottery: 'empezar loteria',
    usePhoneLogin: 'Iniciar sesión con número de móvil',
    useEmailLogin: 'Iniciar sesión por correo electrónico',
    phoneLogin: 'Inicio de sesión de número de móvil',
    countryCodeSearch: 'Ingrese el nombre del país, código de área para buscar',
    emailLogin: 'Correo electrónico de inicio de sesión',
    getAuthCode: 'obtener código de verificación',
    inpPhoneHint: 'Por favor ingrese el número de teléfono',
    inpEmailHint: 'Por favor ingrese su cuenta de correo electrónico',
    inpAuthCode: 'por favor ingrese el código de verificación',
    codeVerifyTitle: 'Por favor complete el control de seguridad',
    codeVerifyHint: 'Desliza hacia la derecha para completar la verificación',
    verifyError: 'Validación fallida',
    verifyFinish: 'cheque completo',
    login: 'Acceso',
    clickCheck: 'clic para ver',
    downAppPrize: 'Descarga la APP para ver los premios',
    lottoErrorHint: 'Código de lotería incorrecto',
    lottoNoloHint: 'Por favor espera pacientemente',
    lottoNowiHint: 'lo siento por no ganar',
    lottoWinnHint: 'Enhorabuena por ganar el premio!!!',
    lottoUsedHint: 'Este código de lotería ya ha sido utilizado',
    partPlatLotto: 'Bienvenido a participar en la lotería de la plataforma.',
    skipPlatLotto: 'Luego salta automáticamente a la página de lotería de la plataforma',
    skipPrize: 'Saltar automáticamente a la página de premios',
    allowMerRead: 'Permitir que los comerciantes accedan a mi información:',
    infoMore: 'nombre, número de teléfono, cumpleaños',
    joinMember: 'unirse a miembro',
    checkMember: 'ver miembros',
    drawPlatCoupon: 'Recibir cupones de la plataforma',
    moreDisDis: 'Más descuentos',
    firLoginDraw: 'La primera vez que inicie sesión en la aplicación, puede obtener',
    clickDown: 'Haga clic para descargar la',
    appDraw: 'aplicación para recibir',
    validTime: 'Válido hasta',
    useAwaCodeHint: 'Úselo en su próxima comida y presente el código de barras al momento de pagar',
    platLottoCode: 'Código de lotería de la plataforma',
    lottoCode: 'Código de sorteo de la suerte:',
    lotteryTime: 'dibujar tiempo: ',
    noLottery: 'no dibujado',
    yetWinning: 'Ha ganado',
    noWinning: 'no ganó',
    haveUsed: 'Usado',
    sellOut: 'Agotado',
    currentPrice: 'Ajustar fecha / hora',
    includeAllergen: 'Incluye alérgenos',
    details: 'Bestelldaten',
    selectAllergen: 'Pagar a la caja',
    rawMaterials: 'materias primas:',
    cookingWay: 'Método de producción:',
    allergens: 'Contiene alérgenos:',
    mayAddMaterials: 'Ingredientes añadibles:',
    mayMinusMaterials: 'Puede reducir los ingredientes:',
    taste: 'Preferencia de sabor:',
    selectedGroupNum: 'Cantidades de placa seleccionadas:',
    priceZero: 'platos al precio 0',
    priceNoZero: 'Platos con precio distinto de 0',
    notSetMealDishes: 'No hay platos en este conjunto',
    notGroupDishes: 'No hay platos en esta categoría',
    notDishesMat: 'No hay materias primas en este plato',
    notGroupMat: 'No hay materias primas en esta categoría',
    selectFinish: 'Seleccionado',
    noSelectFinish: 'Para seleccionar',
    cancel: 'Cancelar',
    woka: {
        activityPage: 'Página del evento',
        unlockDish: 'Desbloquear platos gratis',
        unlockText: '¡Participa en el evento de compartir según las reglas para desbloquear cualquier plato gratis!',
        activityRule: 'Reglas del evento',
        ruleText: 'Elige uno de los siguientes métodos, sube una captura de pantalla en la ubicación designada y recibe un código de canje de plato.',
        issueWork: 'Publicar contenido',
        weChat: 'WeChat',
        wechatText: 'Comparte en tu perfil y consigue 20 "Me gusta" de tus amigos.',
        douyinText1: '1. Participa en el tema #AsistenteDeCocinaAI#',
        douyinText2: '2. Comentario fijado',
        douyinText3: '3. Publica en TikTok @xxxx',
        redBook: 'Xiaohongshu',
        redBookText2: '2. Marca tu ubicación',
        instagramText1: '1. Publica una historia + post/Reels públicos',
        instagramText2: '2. @Menciona a 3 amigos',
        tikTokText1: '1. Historia temporal',
        tikTokText2: '2. Obra pública @menciona a 3 amigos',
        partActivity: 'Participa en el evento',
    }
};
